import { useState } from "react";
import {
  updateProfile,
  fetchBankDetails,
  updateBankDetails,
} from "@/api/profile";
import { useAuth } from "./use-auth";
import { successToast, errorToast } from "@/lib/toast";

export const useEditProfile = () => {
  const {
    astrologer,
    updateAstrologerProfile,
    // updateAstrologerPaymentDetails,
  } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleProfileUpdate = async (updatedData, file) => {
    setLoading(true);

    try {
      const { status, data } = await updateProfile(
        astrologer.astrologerId,
        updatedData,
        file,
        astrologer.accessToken
      );
      if (status === 200) {
        updateAstrologerProfile(data?.data);
        successToast("Profile updated successfully");
      } else {
        errorToast("Failed to update profile");
      }
    } catch (err) {
      console.error(err);
      errorToast("Something went wrong! Please try again later");
    } finally {
      setLoading(false);
    }
  };

  const handleFetchBankDetails = async () => {
    setLoading(true);
    try {
      const { status, data } = await fetchBankDetails(
        astrologer.astrologerId,
        astrologer.accessToken
      );
      if (status === 200) {
        return data;
      } else {
        errorToast("Failed to fetch bank details");
      }
    } catch (err) {
      console.error(err);
      errorToast("Something went wrong! Please try again later");
    } finally {
      setLoading(false);
    }
  };

  const handleBankUpdate = async (bankDetails) => {
    setLoading(true);
    try {
      const { status, data } = await updateBankDetails(
        astrologer.astrologerId,
        bankDetails,
        astrologer.accessToken
      );
      if (status === 200) {
        // updateAstrologerPaymentDetails(data?.data);
        console.log("Astrologer", astrologer);
        updateAstrologerProfile({ ...astrologer, paymentDetails: bankDetails });
        successToast("Bank details updated successfully");
      } else {
        errorToast("Failed to update bank details");
      }
    } catch (err) {
      console.error(err);
      errorToast("Something went wrong! Please try again later");
    } finally {
      setLoading(false);
    }
  };

  return {
    handleProfileUpdate,
    handleFetchBankDetails,
    handleBankUpdate,
    loading,
  };
};
